import { config } from "./config";
import 'isomorphic-fetch';


const apiOrigin = config.URL_API;
const publicOrigin = config.URL_PUBLIC;

const apiFetch = async (url, options) => {
  const response = await fetch(url, options);
  if (response.status === 401) {
    window.dispatchEvent(new CustomEvent('auth:unauthorized'));
  }
  return response;
};

export const fetchCSRFToken = async () => {
  try {
    const response = await apiFetch(apiOrigin + '/csrf', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'AUTHORIZATION': `Bearer ${localStorage.getItem('token')}`
      }
    });

    const data = await response.json();
    if (data && data.csrf_token) {
      sessionStorage.setItem('csrf_token', data.csrf_token);
      return data.csrf_token;
    } else {
      console.error('Error obteniendo CSRF token: formato incorrecto');
      return null;
    }
  } catch (error) {
    console.error('Error obteniendo CSRF token:', error);
    return null;
  }
};

export const publicOptions = (method, data) => {
  let opt = {
    method,
    headers: {
      'Content-Type': 'application/json',
    }
  };
  if (data) {
    opt.body = JSON.stringify(data);
  }
  return opt;
};

export const pivateOptions = (method, data) => {
  const token = localStorage.getItem("token");
  const options = {
    method,
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(data),
  };

  if (token) {
    options.headers.Authorization = `Bearer ${token}`;
  }

  return options;
};

export const mediaOptions = (method, data) => {
  let opt = {
    method,
    headers: {
      'AUTHORIZATION': `Bearer ${localStorage.getItem('token')}`
    }
  };
  if (data) {
    opt.body = data;
  }

  return opt;
};

export const api = {
  csrf: {
    async getToken() {
      return await fetchCSRFToken();
    }
  },
  auth: {
    async getAuthenticatedUser() {
      const response = await apiFetch(apiOrigin + '/authenticate', publicOptions('GET'));
      const data = await response.json();
      return data;
    },
    async Login(data) {
      const response = await fetch(publicOrigin + '/send-code', pivateOptions('POST', data));
      const res = await response.json();
      return res
    },
    async Verify(data) {
      const response = await fetch(publicOrigin + '/verify-code', pivateOptions('POST', data));
      const res = await response.json();
      return res
    },
    async getCurrentUser() {
      const response = await apiFetch(apiOrigin + '/user', pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
  },
  usuarios: {
    async createUsuario(data) {
      const response = await apiFetch(apiOrigin + '/usuarios', pivateOptions('POST', data));
      const res = await response.json();
      return res
    },
    async getUserExist(email) {
      const response = await fetch(`${apiOrigin}/usuario/exist?${email ? `&email=${email}` : ''}`, pivateOptions('GET'));
      const res = await response.json();
      return res
    },
    async getUsuario() {
      const response = await apiFetch(apiOrigin + '/usuario', pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async EditUsuario(data) {
      const response = await apiFetch(apiOrigin + '/usuario', pivateOptions('PUT', data));
      const res = await response.json();
      return res
    },
    async BajaUsuario(email) {
      const response = await apiFetch(apiOrigin + '/usuario/baja', pivateOptions('PUT', { usuario: email }))
      const res = await response.json();
      return res
    },
  },
  eventos: {
    async getPublic(id) {
      // con sesión se manda el token: el staff de un evento privado puede verlo
      // en la vista pública; para el resto un privado no existe
      const opciones = publicOptions('GET');
      const token = localStorage.getItem("token");
      if (token) opciones.headers.Authorization = `Bearer ${token}`;
      const response = await fetch(publicOrigin + '/eventos/' + id, opciones);
      const data = await response.json();
      return data
    },
    async getPreview(id) {
      const response = await fetch(`${apiOrigin}/eventos/preview/${id}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async getAll(q = "", pageSize = 10, currentPage = 0, estado = "Todo") {
      const params = new URLSearchParams({
        sortField: 'id',
        sortOrder: 'desc',
        limit: pageSize.toString(),
        page: currentPage.toString(),
      });

      if (q) {
        params.append('q', q);
      }

      if (estado && estado !== "Todo") {
        params.append('estado', estado);
      }

      const response = await fetch(`${apiOrigin}/eventos?${params.toString()}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async get(id) {
      const response = await apiFetch(apiOrigin + '/eventos/' + id, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async getAllEventosTipos() {
      const response = await apiFetch(apiOrigin + '/eventos/tipos', pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async confirmEvento(idEvento) {
      const response = await apiFetch(apiOrigin + `/eventos/confirm/${idEvento}`, pivateOptions('PUT'));
      const res = await response.json();
      return res
    },
    async createEvento(data) {
      const response = await apiFetch(apiOrigin + '/eventos', pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async deleteEvento(id) {
      const response = await apiFetch(apiOrigin + '/eventos/' + id, pivateOptions('DELETE'));
      const data = await response.json();
      return data;
    },
    async setEvento(id, data) {
      const response = await apiFetch(apiOrigin + '/eventos/' + id, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
    async finishEvento(id) {
      const response = await apiFetch(apiOrigin + '/eventos/' + id + "/finish", pivateOptions('PUT'));
      const res = await response.json();
      return res;
    },
  },

  limites: {
    async getAllLimites() {
      const response = await fetch(apiOrigin + '/limites', pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async getLimitesEvento(idEvento) {
      const response = await fetch(`${apiOrigin}/eventos/${idEvento}/limites`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
  },

  expositores: {


    async createAsistente(eventoId, data) {
      const response = await apiFetch(apiOrigin + '/eventos/' + eventoId + "/expositor/asistente", pivateOptions('POST', data));
      const res = await response.json();
      return res
    },
    async getAllAsistentes(eventoId) {
      const response = await apiFetch(apiOrigin + '/eventos/' + eventoId + "/expositor/asistente", pivateOptions('GET'));
      const res = await response.json();
      return res
    },
    async downloadAsistentesExcel(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/expositor/asistente/excel`, pivateOptions('GET'))
      if (!response.ok) {
        throw new Error('Error al descargar el archivo');
      }
      return await response.blob();
    },
  },
  vendedores: {
    async getVendedores(eventoId, q) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/vendedores/buscar?query=${q}`, pivateOptions('GET'));
      const res = await response.json();
      return res
    },
    /* async getVentasByVendedor(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/ventas/vendedor`, pivateOptions('GET'));
      const res = await response.json();
      return res
    } */
  },
  locations: {
    async getAll(id, q = "", pageSize = 10, currentPage = 0) {
      const response = await apiFetch(apiOrigin + `/ubicaciones?q=${q}&sortField=id&sortOrder=asc&limit=${pageSize}&page=${currentPage}&idevento=${id}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
  },
  ubicacionesNew: {
    // ZONAS/UBICACIONES
    async getAllCompletas(idevento) {
      const response = await fetch(`${apiOrigin}/ubicaciones/completas?idevento=${idevento}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async createUbicacion(data) {
      const response = await fetch(`${apiOrigin}/ubicaciones/nueva`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async updateUbicacion(id, data) {
      const response = await fetch(`${apiOrigin}/ubicaciones/${id}`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
    async deleteUbicacion(id) {
      const response = await fetch(`${apiOrigin}/ubicaciones/${id}`, pivateOptions('DELETE'));
      const data = await response.json();
      return data;
    },
    async getLayoutZona(id) {
      const response = await fetch(`${apiOrigin}/ubicaciones/${id}/layout`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async updateLayoutZona(id, data) {
      const response = await fetch(`${apiOrigin}/ubicaciones/${id}/layout`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
    async updateAsientosEstado(data) {
      const response = await fetch(`${apiOrigin}/asientos/estado`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
    // VISTA PUBLICA
    async getLayoutZonaPublico(id) {
      const response = await fetch(`${publicOrigin}/zonas/${id}/layout`, publicOptions('GET'));
      const data = await response.json();
      return data;
    },
    async getLayoutPorTarifa(idTarifa) {
      const response = await fetch(`${publicOrigin}/tarifas/${idTarifa}/layout`, publicOptions('GET'));
      const data = await response.json();
      return data;
    }
  },
  mapa: {
    async get(idevento) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/mapa`, pivateOptions('GET'));
      return { ...(await response.json()), httpStatus: response.status };
    },
    async guardarBorrador(idevento, version, mapa) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/mapa/borrador`, pivateOptions('PUT', { version, mapa }));
      return { ...(await response.json()), httpStatus: response.status };
    },
    async descartarBorrador(idevento, version) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/mapa/borrador?version=${version}`, pivateOptions('DELETE'));
      return { ...(await response.json()), httpStatus: response.status };
    },
    async publicar(idevento, version, mapa) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/mapa/publicar`, pivateOptions('POST', { version, mapa }));
      return { ...(await response.json()), httpStatus: response.status };
    },
    // para comprar: lugares libres y tarifas a la venta; 404 si el evento no tiene mapa nuevo
    async publico(idevento) {
      const opciones = publicOptions('GET');
      const token = localStorage.getItem("token");
      if (token) opciones.headers.Authorization = `Bearer ${token}`;
      const response = await fetch(`${publicOrigin}/eventos/${idevento}/mapa`, opciones);
      return { ...(await response.json()), httpStatus: response.status };
    },
  },
  ventas: {
    async getAll(id, q = "", pageSize = 10, currentPage = 0) {
      const response = await apiFetch(apiOrigin + `/evento/${id}/ventas?q=${q}&sortField=id&sortOrder=desc&limit=${pageSize}&page=${currentPage}`, pivateOptions('GET'));
      const data = response.json();
      return data;
    },
    async get(id) {
      const response = await apiFetch(apiOrigin + `/evento/venta/${id}`, pivateOptions('GET'));
      const data = response.json();
      return data;
    },
    async getRecibo(id) {
      const response = await apiFetch(apiOrigin + `/evento/venta/${id}/recibo`, pivateOptions('GET'));
      const data = response.json();
      return data;
    },
    async getReciboPDF(id, idCompra) {
      const response = await fetch(`${apiOrigin}/evento/venta/${id}/recibo/download`, pivateOptions('GET'))
      const data = response.blob()
      return data
    },
    async getVentasCaja(id, q = "", pageSize = 10, currentPage = 0) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/ventas-caja?q=${q}&sortField=id&sortOrder=desc&limit=${pageSize}&page=${currentPage}`, pivateOptions('GET'));
      const data = response.json();
      return data;
    },
  },
  caja: {
    async createCaja(id, data) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/cajas`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getAllCajas(id) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/cajas`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getPasarelaEvento(id) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/pasarela`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getCaja(id, cajaId) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/caja/${cajaId}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async updateCaja(id, cajaId, data) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/caja/${cajaId}`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
    async deleteCaja(id, cajaId) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/caja/${cajaId}`, pivateOptions('DELETE'));
      const data = await response.json();
      return data;
    },
    async getCierreZeta(id, cajaId) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/caja/${cajaId}/cierre`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async generarPreimpresos(id, cajaId, data) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/caja/${cajaId}/preimpresos`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async asignarPin(id, cajaId, data) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/caja/${cajaId}/pin`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
  },
  stock: {
    async createStock(id, data) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/stock`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getAllStock(id) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/stock`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
  },
  categorias: {
    async getAll(id, q = '', pageSize = 10, currentPage = 0) {
      const response = await apiFetch(apiOrigin + `/categorias?q=${q}&sortField=id&sortOrder=asc&limit=${pageSize}&page=${currentPage}&idevento=${id}`, pivateOptions('GET'));
      const data = response.json();
      return data;
    },
  },

  publicaciones: {
    async getAllActive(q = '', pageSize = 10, currentPage = 0) {
      const response = await fetch(`${publicOrigin}/eventos/publicaciones/activas?q=${q}&sortField=id&sortOrder=asc&limit=${pageSize}&page=${currentPage}`, publicOptions('GET'));
      const data = await response.json();
      return data;
    },
    async getAll(id, q = "", pageSize = 10, currentPage = 0) {
      const response = await fetch(`${apiOrigin}/publicaciones?q=${q}&sortField=id&sortOrder=asc&limit=${pageSize}&page=${currentPage}&idevento=${id}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async get(id) {
      const response = await fetch(`${apiOrigin}/publicaciones/${id}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async createPublicacion(data) {
      const response = await fetch(`${apiOrigin}/publicaciones`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async deletePublicacion(id) {
      const response = await fetch(`${apiOrigin}/publicaciones/${id}`, pivateOptions('DELETE'));
      const data = await response.json();
      return data;
    },
    async updatePublicacion(data) {
      const response = await fetch(`${apiOrigin}/publicaciones`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
  },

  faqs: {
    async getAll(id) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/faqs`, pivateOptions('GET'));
      const data = response.json();
      return data;
    },
    async createFaqs(id, data) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/faqs`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async editFaqs(id, idfaqs, data) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/faqs/${idfaqs}`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
    async reordenarFaqs(id, ids) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/faqs/orden`, pivateOptions('PUT', { ids }));
      return await response.json();
    },
    async deleteFaqs(id, idfaqs) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/faqs/${idfaqs}`, pivateOptions('DELETE'));
      const res = await response.json();
      return res;
    },
  },

  eventoCuentas: {
    async getAll(id) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/cuentas`, pivateOptions('GET'));
      const data = response.json();
      return data;
    },
    async get(id) {
      const response = await apiFetch(apiOrigin + `/eventos/cuentas/${id}`, pivateOptions('GET'));
      const data = response.json();
      return data;
    },
    async createCuenta(id, data) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/cuentas`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async setEventoCuenta(id, data) {
      const response = await apiFetch(apiOrigin + `/eventos/cuentas/${id}`, pivateOptions('PUT', data));
      const res = response.json();
      return res;
    },
    async deleteEventoCuenta(id) {
      const response = await apiFetch(apiOrigin + `/eventos/cuentas/${id}`, pivateOptions('DELETE'));
      const data = response.json();
      return data;
    },
  },

  mercadopago: {
    async createPago(data) {
      const response = await apiFetch(apiOrigin + "/payment", pivateOptions('POST', data));
      const res = response.json();
      return res;
    },
    async createPagoQR(id, data) {
      const response = await fetch(`${apiOrigin}/${id}/payment/qr`, pivateOptions('POST', data));
      const res = response.json();
      return res;
    },
    async generateQR(carritoId) {
      const response = await fetch(`${apiOrigin}/mercadopago/qr/${carritoId}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    /* async generateQRNEW(carritoId) {
      const response = await fetch(`${apiOrigin}/mercadopago/qr-oauth/${carritoId}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    }, */
    async vincularCuenta(data) {
      const response = await apiFetch(apiOrigin + "/vinculation", pivateOptions('POST', data));
      const res = response.json();
      return res;
    },
    async desvincularCuenta(id) {
      const response = await apiFetch(apiOrigin + `/desvinculation/${id}`, pivateOptions('DELETE', id));
      const res = response.json();
      return res;
    },
  },

  notificaciones: {
    async getNotificaciones() {
      const response = await fetch(`${apiOrigin}/notificaciones`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },

    async atenderSolicitud(id, data) {
      const response = await fetch(`${apiOrigin}/notificacion/${id}`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },

    async eliminarNotificacion(id) {
      const response = await fetch(`${apiOrigin}/notificacion/${id}`, pivateOptions('DELETE'));
      const res = await response.json()
      return res;
    }
  },

  inscripciones: {
    async createInscripcion(id, data) {
      const response = await fetch(`http://localhost:7001/public/eventos/${id}/inscripcion`, publicOptions('POST', data));
      const res = response.json();
      return res;
    },
  },
  tarifas: {
    async getAll(id, q = "", pageSize = 100, currentPage = 1, idtipo = "") {
      const response = await apiFetch(apiOrigin + `/tarifas?q=${q}&sortField=id&sortOrder=asc&limit=${pageSize}&page=${currentPage}&idevento=${id}&idtipo=${idtipo}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async createTarifa(data) {
      const response = await apiFetch(apiOrigin + `/tarifas`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async updateTarifa(id, data) {
      const response = await apiFetch(apiOrigin + `/tarifas/${id}`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
    async deleteTarifa(id) {
      const response = await apiFetch(apiOrigin + `/tarifas/${id}`, pivateOptions('DELETE'));
      const data = await response.json();
      return data;
    },
    async getTarifasSinDiseno(idevento) {
      const response = await fetch(`${apiOrigin}/${idevento}/tarifas/sindiseno`, pivateOptions("GET"));
      const res = await response.json();
      return res;
    },
    async getTarifaByEventoWithoutPagination(idevento) {
      const response = await fetch(`${apiOrigin}/eventos/${idevento}/tarifas-evento`, pivateOptions("GET"));
      const res = await response.json();
      return res;
    },
  },
  solicitudes: {
    async getMisSolicitudes() {
      const response = await apiFetch(`${apiOrigin}/usuario/solicitudes`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getPendientes(idevento, q = "") {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/solicitudes?${q}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async aprobar(id) {
      const response = await apiFetch(`${apiOrigin}/solicitudes/${id}/aprobar`, pivateOptions('PUT'));
      const res = await response.json();
      return res;
    },
    async rechazar(id, observaciones) {
      const response = await apiFetch(`${apiOrigin}/solicitudes/${id}/rechazar`, pivateOptions('PUT', { observaciones }));
      const res = await response.json();
      return res;
    },
    async descargarReporte(idevento) {
      const response = await fetch(`${apiOrigin}/eventos/${idevento}/solicitudes/reporte`, pivateOptions('GET'));
      const res = await response.blob();
      return res;
    }
  },
  talonarios: {
    async getAllTalonarios(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/talonarios`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getTalonariosByTarifa(eventoId, tarifaId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/talonarios/${tarifaId}/disponibles`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async asignarTalonario(eventoId, data) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/talonarios/asignar`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getTalonarioByVendedor(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/talonarios/vendedor`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getTalonariosByTesorero(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/talonarios/tesorero`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getTarifasAsignadas(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/tarifas-asignadas`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    }
  },
  rendiciones: {
    async generarResumenVendedor(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/rendiciones/resumen`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    /* async enviarRendicion(eventoId, data) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/rendiciones`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    }, */
    async rendirVendedor(eventoId, data) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/rendiciones`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    /* async getHistorialByVendedor(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/rendiciones/historial`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    }, */
    async getTalonariosPendientesDeRendicion(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/rendiciones/pendientes`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    /* async getRendicionPendienteByTalonario(eventoId, talonarioId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/talonarios/${talonarioId}/rendicion-pendiente`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    }, */
    async confirmarRendicion(rendicionId) {
      const response = await fetch(`${apiOrigin}/rendiciones/${rendicionId}/confirmar`, pivateOptions('PUT'));
      const res = await response.json();
      return res;
    },
    async rechazarRendicion(rendicionId, data) {
      const response = await fetch(`${apiOrigin}/rendiciones/${rendicionId}/rechazar`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
    async getTesoreroDashboard(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/tesorero/dashboard`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async rendirEfectivo(eventoId, data) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/rendiciones/rendir`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getCajasRendiciones(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/rendiciones/cajas`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getUsuariosSaldos(eventoId) {
      const response = await fetch(`${apiOrigin}/eventos/${eventoId}/rendiciones/saldos`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    }
  },
  tickets: {
    async getTickets(idEvento, q = "", pageSize = 10, currentPage = 0) {
      const response = await apiFetch(apiOrigin + `/eventos/${idEvento}/tickets?q=${q}&sortField=id&sortOrder=desc&limit=${pageSize}&page=${currentPage}`, pivateOptions('GET'));
      const res = await response.json();
      return res
    },
    async darDeBajaTicket(ticketId, motivo) {
      const response = await fetch(`${apiOrigin}/tickets/${ticketId}/baja`, pivateOptions('PUT', { motivo }));
      const res = await response.json();
      return res;
    },
    async setAccesoTicket(id, qr) {
      const response = await apiFetch(apiOrigin + '/eventos/' + id + "/" + qr, pivateOptions('PUT'));
      const data = await response.json();
      return data;
    },
    async getTicketEvento(id) {
      const response = await apiFetch(apiOrigin + '/eventos/tickets/' + id, pivateOptions('GET'));
      const data = await response.json();
      return data
    },
    async createTicket(id, data) {
      const response = await apiFetch(apiOrigin + '/eventos/' + id + "/ticket", pivateOptions('POST', data));
      const res = await response.json();
      return res
    },
    async createTickets(id, data) {
      const response = await apiFetch(apiOrigin + '/eventos/' + id + "/tickets", pivateOptions('POST', data));
      const res = await response.json();
      return res
    },
    async setSalidaTicket(id, qr, salida) {
      const response = await apiFetch(apiOrigin + '/eventos/' + id + "/" + qr + "/" + salida, pivateOptions('PUT'));
      const data = await response.json();
      return data;
    },
    async getTicketByEvento(idEvento, idcategoria, query = '', page = 1) {
      const response = await fetch(`${apiOrigin}/eventos/${idEvento}/tickets?q=${query}${idcategoria ? `&idcategoria=${idcategoria}` : ''}&page=${page}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async getExcelTickets(id) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/ticketsexcel`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async createExcelTickets(id, formData) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/ticketsexcel`, mediaOptions('POST', formData));
      return response.json();
    },
    async importarRespuestas(id, formData) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/importar-respuestas`, mediaOptions('POST', formData));
      return response.json();
    },
    async descargarPlantillaRespuestas(eventoId, tarifaId) {
      const response = await fetch(
        `${apiOrigin}/eventos/${eventoId}/importar-respuestas/plantilla/${tarifaId}`,
        pivateOptions('GET')
      );
      return response.blob();
    },
    async getInformacionAdicional(ticketCodigo) {
      const response = await fetch(`${publicOrigin}/ticket/${ticketCodigo}/informacion`, publicOptions('GET'));
      return await response.json();
    },

    async saveInformacionAdicional(ticketCodigo, respuestas) {
      const response = await fetch(`${publicOrigin}/ticket/${ticketCodigo}/informacion`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          respuestas: respuestas
        })
      });
      return await response.json();
    },
    //EXCEL RECEPCIONES
    async getExcelRecepciones(id) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/recepciones/plantilla`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async createExcelRecepciones(id, formData) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/recepciones/tickets`, mediaOptions('POST', formData));
      return response.json();
    },
  },

  vouchers: {
    async getVouchers(idEvento, q = "", pageSize = 10, currentPage = 0) {
      const response = await apiFetch(apiOrigin + `/eventos/${idEvento}/vouchers?q=${q}&sortField=id&sortOrder=desc&limit=${pageSize}&page=${currentPage}`, pivateOptions('GET'));
      const res = await response.json();
      return res
    },

    async getVouchersByEvento(idEvento, page = 1) {
      const response = await fetch(`${apiOrigin}/eventos/${idEvento}/vouchers?q=&page=${page}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },

    async getVoucherById(id) {
      const response = await fetch(`${apiOrigin}/eventos/vouchers/${id}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },

    async updateVoucherImage(idevento, idvoucher) {
      const response = await fetch(`${apiOrigin}/eventos/${idevento}/impresion/updateVoucher/${idvoucher}`, pivateOptions('PUT'));
      const data = await response.json();
      return data;
    },
    async createVouchers(id, data) {
      const response = await apiFetch(apiOrigin + '/eventos/' + id + "/vouchers", pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },

    async createVouchersExcel(idEvento, data) {
      const response = await apiFetch(apiOrigin + '/eventos/' + idEvento + "/crearvouchers", pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getDisponiblesVendedor(Idevento, Idtarifa) {
      const response = await apiFetch(apiOrigin + `/eventos/${Idevento}/tarifas/${Idtarifa}/disponibles`, pivateOptions('GET'));
      const res = await response.json();
      return res
    },
    async darDeBajaVoucher(voucherId, motivo) {
      const response = await fetch(`${apiOrigin}/vouchers/${voucherId}/baja`, pivateOptions('PUT', { motivo }));
      const res = await response.json();
      return res;
    },
  },

  participaciones: {
    async getParticipaciones() {
      const response = await fetch(`${apiOrigin}/participaciones`, pivateOptions('GET'));
      const data = response.json();
      return data;
    },
    async getParticipacionesByEvento(eventoId, q = "", pageSize = 10, currentPage = 1) {
      const response = await fetch(`${apiOrigin}/participaciones/evento/${eventoId}?q=${encodeURIComponent(q)}&limit=${pageSize}&page=${currentPage}`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async createParticipacion(data) {
      const response = await fetch(`${apiOrigin}/participaciones`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async deleteParticipacion(id) {
      const response = await fetch(`${apiOrigin}/participaciones/${id}`, pivateOptions('DELETE'));
      const data = await response.json();
      return data;
    },
    async updateSubrol(data) {
      const response = await fetch(`${apiOrigin}/participaciones/subrol`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
    async setPinVendedor(data) {
      const response = await fetch(`${apiOrigin}/participaciones/pin`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    }
  },

  carrito: {
    async getCarrito() {
      const response = await fetch(`${apiOrigin}/carrito/activo`, pivateOptions('GET'));
      const data = response.json();
      return data;
    },
    async crearCarrito(data) {
      const response = await fetch(`${apiOrigin}/carrito/crear`, pivateOptions('POST', data));
      const res = response.json();
      return res;
    },
    async sumarRestarItems(data) {
      const response = await fetch(`${apiOrigin}/carrito/agregar`, pivateOptions('PUT', data));
      const res = response.json();
      return res;
    },
    async eliminarItem(id) {
      const response = await fetch(`${apiOrigin}/carrito/eliminar/${id}`, pivateOptions('DELETE'));
      const data = response.json();
      return data;
    },
    async crearCarritoCaja(data) {
      const response = await fetch(`${apiOrigin}/carrito/caja`, pivateOptions('POST', data));
      const res = response.json();
      return res;
    },
  },

  media: {
    async uploadLocal(files) {
      const response = await apiFetch(apiOrigin + '/media/upload-local', mediaOptions('POST', files))
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    },
    async deleteLocal(id) {
      const response = await apiFetch(apiOrigin + '/media/delete-local', pivateOptions('DELETE', id))
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    }
  },

  email: {
    async reSend(compraId) {
      const response = await apiFetch(apiOrigin + `/pagotic/resend-email/${compraId}`, pivateOptions('POST'));
      const res = await response.json();
      return res
    }
  },
  impresion: {
    async uploadImage(id, data, idTarifa) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/impresion/imageUpload?idTarifa=${idTarifa}`, pivateOptions("POST", data))
      const res = response.json()
      return res
    },
    async getImages(id) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/impresion/imageUpload`, pivateOptions("GET"))
      const res = response.json()
      return res
    },
    async deleteImage(id, idImage) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/impresion/imageDelete/${idImage}`, pivateOptions("DELETE"))
      const res = response.json()
      return res
    },
    async getAll(idevento) {
      const response = await fetch(`${apiOrigin}/eventos/${idevento}/impresion`, pivateOptions("GET"));
      const res = await response.json();
      return res;
    },
    async getById(id) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/impresion`, pivateOptions('GET'));
      const res = response.json();
      return res;
    },
    async getDisenoByID(iddiseno) {
      const response = await fetch(`${apiOrigin}/eventos/${iddiseno}/diseno`, pivateOptions('GET'));
      const res = response.json();
      return res;
    },
    async create(idevento, iddiseno, data) {
      const response = await fetch(`${apiOrigin}/eventos/${idevento}/impresion/${iddiseno}`, pivateOptions('POST', data));
      const res = response.json();
      return res;
    },
    async update(idevento, iddiseno, data) {
      const response = await fetch(`${apiOrigin}/eventos/${idevento}/impresion/${iddiseno}`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
    async duplicar(idevento, iddiseno, idtarifa) {
      const response = await fetch(`${apiOrigin}/eventos/${idevento}/impresion/${iddiseno}/${idtarifa}`, pivateOptions('PUT'), null);
      const res = await response.json();
      return res;
    },
    async deleteDiseno(idevento, iddiseno, force = false) {
      const url = `${apiOrigin}/eventos/${idevento}/impresion/${iddiseno}${force ? '?force=true' : ''}`;
      const response = await fetch(url, pivateOptions('DELETE'));
      const res = await response.json();
      return res;
    },
    async download(id) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/impresion/download`, pivateOptions('GET'));
      const res = await response.blob();
      return res;
    },
    // async verifyDesign() {
    // },
    async downloadImpresionConFiltro(id, tarifaId) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/impresion/${tarifaId}/download`, pivateOptions('GET'));
      if (!response.ok) {
        return await response.json();
      }
      const resBlob = await response.blob();
      return resBlob;
    },
    async downloadImpresionVoucher(id, tarifaId) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/impresion/${tarifaId}/downloadVoucher`, pivateOptions('GET'));
      // const response = await apiFetch(apiOrigin + `/eventos/${id}/impresion/${tarifaId}/downloadVoucher?desde=2010&hasta=2309`, pivateOptions('GET'));
      if (!response.ok) {
        return await response.json();
      }
      const resBlob = await response.blob();
      return resBlob;
    },
  },
  plantillas: {
    async getAllPlantillas() {
      const response = await fetch(`${apiOrigin}/plantillas`, pivateOptions("GET"));
      const res = await response.json();
      return res;
    },
    async getPlantilla(id) {
      const response = await fetch(`${apiOrigin}/plantillas/${id}`, pivateOptions("GET"));
      const res = await response.json();
      return res;
    },
    async createPlantilla(data) {
      const response = await fetch(`${apiOrigin}/plantillas`, pivateOptions("POST", data));
      const res = await response.json();
      return res;
    },
    async deletePlantilla(id) {
      const response = await fetch(`${apiOrigin}/plantillas/${id}`, pivateOptions('DELETE'));
      const res = await response.json();
      return res;
    }
  },
  accesos: {
    async setVoucher(id, qr) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/voucher/${qr}`, pivateOptions('PUT'));
      const data = await response.json();
      return data;
    },
    async getTicketAccesos(idEvento, idTicket) {
      const response = await fetch(`${apiOrigin}/eventos/${idEvento}/tickets/${idTicket}/accesos`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getTarifasAccesos(idEvento, idusuario = null) {
      let url = `${apiOrigin}/eventos/${idEvento}/colaboradores-accesos`;
      if (idusuario) url += `?idusuario=${idusuario}`;
      const response = await fetch(url, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async asignarTarifaColaborador(idEvento, data) {
      const response = await fetch(`${apiOrigin}/eventos/${idEvento}/colaboradores-accesos`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async eliminarTarifaColaborador(idEvento, id) {
      const response = await fetch(`${apiOrigin}/eventos/${idEvento}/colaboradores-accesos/${id}`, pivateOptions('DELETE'));
      const res = await response.json();
      return res;
    },
  },

  consultas: {
    async create(data) {
      const response = await fetch(publicOrigin + '/consultas', publicOptions('POST', data));
      const res = await response.json();
      return res;
    },
  },

  facturacion: {
    async getFacturacion() {
      const response = await fetch(`${apiOrigin}/facturacion`, pivateOptions('GET'));
      const data = await response.json();
      return data;
    },
    async createFacturacion(data) {
      const response = await fetch(`${apiOrigin}/facturacion`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async updateFacturacion(data) {
      const response = await fetch(`${apiOrigin}/facturacion`, pivateOptions('PUT', data));
      const res = await response.json();
      return res;
    },
  },

  cookies: {
    async updateCookies(data) {
      const response = await fetch(`${publicOrigin}/cookies/consent`, publicOptions('POST', data));
      const res = await response.json();
      return res;
    }
  },

  seguimiento: {
    async config(idevento) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/seguimiento`, pivateOptions('GET'));
      return response.json();
    },
    async guardar(idevento, config) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/seguimiento`, pivateOptions('PUT', config));
      return response.json();
    },
    async publico(idevento) {
      const response = await fetch(`${publicOrigin}/eventos/${idevento}/seguimiento`, publicOptions('GET'));
      return response.json();
    },
    // manda una compra de prueba a Meta con el código de prueba del evento
    async probar(idevento) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/seguimiento/probar`, pivateOptions('POST'));
      return response.json();
    },
    // datos del Purchase de una compra propia, por su referencia externa
    // por referencia externa o, en los pagos con QR, por { idcarrito }
    async compra(referencia) {
      const ruta = referencia?.idcarrito
        ? `compras/carrito/${referencia.idcarrito}`
        : `compras/referencia/${encodeURIComponent(referencia)}`;
      const response = await apiFetch(`${apiOrigin}/${ruta}/seguimiento`, pivateOptions('GET'));
      return response.json();
    },
    // estado de una compra de cualquier pasarela (misma forma que el de PVS)
    async estadoCompra(referencia) {
      const response = await apiFetch(`${apiOrigin}/compras/referencia/${encodeURIComponent(referencia)}/estado`, pivateOptions('GET'));
      const data = await response.json();
      if (!response.ok) throw Object.assign(new Error(data.message || data.error), { status: response.status });
      return data;
    },
  },
  canales: {
    async listar(idevento) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/canales`, pivateOptions('GET'));
      return response.json();
    },
    async crear(idevento, canal) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/canales`, pivateOptions('POST', canal));
      return response.json();
    },
    async editar(idevento, idcanal, cambios) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/canales/${idcanal}`, pivateOptions('PUT', cambios));
      return response.json();
    },
    async borrar(idevento, idcanal) {
      const response = await apiFetch(`${apiOrigin}/eventos/${idevento}/canales/${idcanal}`, pivateOptions('DELETE'));
      return response.json();
    },
    // reporte: "canales" o "campanias"; con formato "xlsx" devuelve el archivo
    async reporte(idevento, reporte, { desde, hasta, formato } = {}) {
      const params = new URLSearchParams();
      if (desde) params.set('desde', desde);
      if (hasta) params.set('hasta', hasta);
      if (formato) params.set('formato', formato);
      const response = await apiFetch(`${apiOrigin}/reportes/${idevento}/${reporte}?${params}`, pivateOptions('GET'));
      return formato === 'xlsx' ? response.blob() : response.json();
    },
    // públicos
    async usaCodigos(idevento) {
      const response = await fetch(`${publicOrigin}/eventos/${idevento}/canales`, publicOptions('GET'));
      return response.json();
    },
    async visita(idevento, codigo) {
      await fetch(`${publicOrigin}/eventos/${idevento}/canales/visita`, publicOptions('POST', { codigo }));
    },
  },
  reporte: {
    async downloadReporte(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async downloadReporteTicket(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}/tickets`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async downloadReporteVoucher(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}/vouchers`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async downloadReporteVentas(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}/ventas`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async downloadReporteDetalle(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}/pagos`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async downloadReporteParticipantes(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}/participantes`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async downloadReporteDetalleCaja(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}/detalle-caja`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async downloadReporteVentasTickets(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}/ventas-tickets`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async downloadReporteVentasVouchers(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}/ventas-vouchers`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async downloadReporteRecaudacion(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}/recaudacion`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },
    async downloadReporteCajas(id) {
      const response = await fetch(`${apiOrigin}/reportes/${id}/cajas`, pivateOptions('GET'))
      const res = await response.blob();
      return res
    },

  },

  fechas: {
    async getAllFechasEvento(id) {
      const response = await fetch(`${apiOrigin}/eventos/${id}/fechas`, pivateOptions('GET'))
      const res = await response.json();
      return res;
    }
  },

  infoAdicional: {
    async getPregunta(id, idTarifa) {
      const response = await apiFetch(apiOrigin + `/eventos/${id}/infoadicional?idtarifa=${idTarifa}`, pivateOptions('GET'));
      const res = await response.json();
      return res
    },
  },
  maps: {
    async getEmbedURL(address) {
      const response = await fetch(`${publicOrigin}/maps/embed?address=${encodeURIComponent(address)}`, publicOptions('GET'));
      const data = await response.json();
      return data;
    }
  },
  pagotic: {
    async createCredential(data) {
      const response = await fetch(`${apiOrigin}/credenciales/pagotic`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getCredential() {
      const response = await fetch(`${apiOrigin}/credenciales/pagotic`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getCredentialById(id) {
      const response = await fetch(`${apiOrigin}/credenciales/pagotic/${id}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async deleteCredential(id) {
      const response = await fetch(`${apiOrigin}/credenciales/pagotic/${id}`, pivateOptions('DELETE'));
      const res = await response.json();
      return res;
    },
    async assignCredential(data) {
      const response = await fetch(`${apiOrigin}/credenciales/pagotic/evento`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getCredentialForEvent(id, data) {
      const response = await fetch(`${apiOrigin}/credenciales/pagotic/evento/${id}`, pivateOptions('GET', data));
      const res = await response.json();
      return res;
    },
    async unlinkCredential(id) {
      const response = await fetch(`${apiOrigin}/credenciales/pagotic/evento/${id}`, pivateOptions('DELETE'));
      const res = await response.json();
      return res;
    },
  },
  pvs: {
    async generatePVSQr(data) {
      const response = await fetch(`${apiOrigin}/payment/pvs`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async generatePVSLink(data) {
      const response = await fetch(`${apiOrigin}/payment/pvs/generate-link`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getStatusPayment(reference) {
      const response = await fetch(`${apiOrigin}/payment-status/${reference}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getQRPaymentStatus(qrId) {
      const response = await fetch(`${apiOrigin}/payment-status-qr/${qrId}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async createCredential(data) {
      const response = await fetch(`${apiOrigin}/credenciales/pvs`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getCredential() {
      const response = await fetch(`${apiOrigin}/credenciales/pvs`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getCredentialById(id) {
      const response = await fetch(`${apiOrigin}/credenciales/pvs/${id}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async deleteCredential(id) {
      const response = await fetch(`${apiOrigin}/credenciales/pvs/${id}`, pivateOptions('DELETE'));
      const res = await response.json();
      return res;
    },
    async assignCredential(data) {
      const response = await fetch(`${apiOrigin}/credenciales/pvs/evento`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getCredentialForEvent(id, data) {
      const response = await fetch(`${apiOrigin}/credenciales/pvs/evento/${id}`, pivateOptions('GET', data));
      const res = await response.json();
      return res;
    },
    async unlinkCredential(id) {
      const response = await fetch(`${apiOrigin}/credenciales/pvs/evento/${id}`, pivateOptions('DELETE'));
      const res = await response.json();
      return res;
    },
  },
  clickmacro: {
    async createCredential(data) {
      const response = await fetch(`${apiOrigin}/credenciales/click`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getCredential() {
      const response = await fetch(`${apiOrigin}/credenciales/click`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getCredentialById(id) {
      const response = await fetch(`${apiOrigin}/credenciales/click/${id}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async deleteCredential(id) {
      const response = await fetch(`${apiOrigin}/credenciales/click/${id}`, pivateOptions('DELETE'));
      const res = await response.json();
      return res;
    },
    async assignCredential(data) {
      const response = await fetch(`${apiOrigin}/credenciales/click/evento`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    async getCredentialForEvent(id, data) {
      const response = await fetch(`${apiOrigin}/credenciales/click/evento/${id}`, pivateOptions('GET', data));
      const res = await response.json();
      return res;
    },
    async unlinkCredential(id) {
      const response = await fetch(`${apiOrigin}/credenciales/click/evento/${id}`, pivateOptions('DELETE'));
      const res = await response.json();
      return res;
    },
    generateClickMacroQr: async (data, tipo = 'presencial') => {
      const tipoParam = tipo !== 'presencial' ? `?tipo=${tipo}` : '';
      const response = await fetch(`${apiOrigin}/payment/clickmacro${tipoParam}`, pivateOptions('POST', data));
      const res = await response.json();
      return res;
    },
    getPaymentStatus: async (referencia) => {
      const response = await fetch(`${apiOrigin}/payment/clickmacro/status/${referencia}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    getPaymentStatusByOrderId: async (orderId) => {
      const response = await fetch(`${apiOrigin}/payment/clickmacro/status-by-order/${orderId}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    /* getPaymentDetails: async (reference) => {
      const response = await fetch(`${apiOrigin}/payment/clickmacro/details/${reference}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    }, */
  },
  mundo: {
    async getAllCountries() {
      const response = await fetch(`${apiOrigin}/countries`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getStatesByCountry(id) {
      const response = await fetch(`${apiOrigin}/countries/${id}/states`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async getCitiesByStates(id) {
      const response = await fetch(`${apiOrigin}/states/${id}/cities`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
    async findCityByName(name, countryId) {
      const params = new URLSearchParams({ name });
      if (countryId) params.append('country_id', countryId);
      const response = await fetch(`${apiOrigin}/cities?${params.toString()}`, pivateOptions('GET'));
      const res = await response.json();
      return res;
    },
  }
};
